module.exports = __webpack_public_path__ + "./MalikPhoto_7b3be19144f7bbfa75ec21b4ef78ced8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/MalikPhoto.png
// module id = 535
// module chunks = 0